import { createAction, props } from '@ngrx/store';
import { UserModel } from '../../../models/vet-users/user.model';

// Load Users
export const loadUsers = createAction('[User] Load Users');
export const loadUsersSuccess = createAction('[User] Load Users Success', props<{ users: UserModel[] }>());
export const loadUsersFailure = createAction('[User] Load Users Failure', props<{ error: any }>());

// Save User
export const saveUser = createAction('[User] Save User', props<{ user: UserModel }>());
export const saveUserSuccess = createAction('[User] Save User Success', props<{ user: boolean }>());
export const saveUserFailure = createAction('[User] Save User Failure', props<{ error: any }>());

//forgot password
export const forgotPasswordByUserId = createAction( '[User] Forgot Password By UserId',props<{ userId: number }>());
export const forgotPasswordByUserIdSuccess = createAction('[User] Forgot Password By UserId Success',props<{ success: boolean }>());
export const forgotPasswordByUserIdFailure = createAction('[User] Forgot Password By UserId Failure', props<{ error: any }>());

//Get User
export const getUser = createAction('[User] Get User', props<{ userId: number }>());
export const getUserSuccess = createAction('[User] Get User Success', props<{ user: UserModel }>());
export const getUserFailure = createAction('[User] Get User Failure', props<{ error: any }>());
